import React from 'react';

export default function ErrorPage(): JSX.Element {
  return (
    <>
      <h1>Error Boundary Demo</h1>
      <p>{renderSomeError()}</p>
    </>
  );
}

function renderSomeError(): never {
  throw new Error('some error');
}
